<!--This file is nothing but a proxy-->
<!--We need it to -->
<template>
  <router-view />
</template>
<script setup lang="ts">
</script>
